<wiz-vgroup horizontalAlign="center" width="100%" height="100%" 
style="padding-right: 3px;" class="section-container">
    <wiz-vgroup width="100%" style="padding-top: 10px; padding-bottom: 10px;">
    
        <wiz-hgroup width="100%">
            <img src="assets/logo/logo-mobile512.png" width="30px" height="30px"/>
            <wiz-label [wizLabel]="'Texdecor Mobile Apps'" class="headerTitle" width="100%"></wiz-label>
        </wiz-hgroup>

        <wiz-hgroup width="100%" horizontalAlign="center">
            <wiz-label #lblUser></wiz-label>
        </wiz-hgroup>
        
        <wiz-spacer height="20px"></wiz-spacer>
        <hr style="height: 1; width: 90%;">
        <wiz-hgroup verticalAlign="center" [visible]="doShow('init')" (click)="do('home')" width="100%">
            <wiz-icon class="basicIcon black hover"><mat-icon>home</mat-icon></wiz-icon>
            <wiz-label wizLabel="$.common.home.$" style="cursor: pointer;"></wiz-label>
        </wiz-hgroup>
        <wiz-hgroup verticalAlign="center" [visible]="doShow('thumb')" (click)="do('thumb')">
            <wiz-icon class="basicIcon black hover" >view-thumbnail</wiz-icon>
            <wiz-label wizLabel="$.widget.show.thumb.$" style="cursor: pointer;"></wiz-label>
        </wiz-hgroup>
        <wiz-hgroup verticalAlign="center" [visible]="doShow('list')" (click)="do('list')">
            <wiz-icon class="basicIcon black hover" >view-list</wiz-icon>
            <wiz-label wizLabel="$.widget.show.list.$" style="cursor: pointer;"></wiz-label>
        </wiz-hgroup>
        <wiz-hgroup verticalAlign="center" [visible]="doShow('add')" (click)="do('add')">
            <wiz-icon class="basicIcon black hover" >item</wiz-icon>
            <wiz-label wizLabel="$.widget.show.add.$" style="cursor: pointer;"></wiz-label>
        </wiz-hgroup>

        <wiz-hgroup verticalAlign="center" [visible]="doShow('gatling')" (click)="do('gatling')">
            <wiz-icon class="basicIcon black hover"><mat-icon>bolt</mat-icon></wiz-icon>
            <wiz-label wizLabel="$.widget.show.mass.$" style="cursor: pointer;"></wiz-label>
        </wiz-hgroup>

         <wiz-hgroup verticalAlign="center" [visible]="isVerbose" (click)="do('log')">
            <wiz-icon class="basicIcon black hover"><mat-icon>pets</mat-icon></wiz-icon>
            <wiz-label wizLabel="$.widget.show.log.$" style="cursor: pointer;"></wiz-label>
        </wiz-hgroup>


        <wiz-spacer height="10px"></wiz-spacer>

        <hr style="height: 1; width: 90%;">

        
        <wiz-hgroup verticalAlign="center" (click)="do('refresh')" width="100%">
            <wiz-icon class="basicIcon black hover" 
                    >undo</wiz-icon>
            <wiz-label wizLabel="$.common.refresh.cache.$"></wiz-label>
        </wiz-hgroup>
        <wiz-hgroup verticalAlign="center" (click)="do('clearCache')" width="100%">
            <wiz-icon class="basicIcon black hover" 
                    >delete</wiz-icon>
            <wiz-label wizLabel="$.common.clear.cache.$"></wiz-label>
        </wiz-hgroup>
        <wiz-hgroup verticalAlign="center" (click)="do('clearContext')" width="100%">
            <wiz-icon class="basicIcon black hover" 
                    >delete</wiz-icon>
            <wiz-label wizLabel="$.common.clear.context.$"></wiz-label>
        </wiz-hgroup>

        <wiz-spacer height="10px"></wiz-spacer>
        <wiz-hgroup horizontalAlign="end">
            <wiz-label [wizLabel]="applicationVersion"></wiz-label>  
        </wiz-hgroup>    

    </wiz-vgroup>



</wiz-vgroup>